import { _bootstrap } from "state/store.bootstrap";
import { getFocus, useAtom, useGet } from "state/jotai";
import {
  active_project,
  current_language,
  rotate_by_slider,
} from "state/store.global";
import { AnimatePresence, motion } from "framer-motion";
import { useBreak } from "hooks/useBreak";
import { InnerDesktopLabel } from "./InnerDesktopLabel";

/** ================= CONFIG (moved outside) ================= */

const DEFAULT_POS = { L1: [1680, 1050], L2: [2700, 1200] };
const DEFAULT_RADIUS = { L1: [50, 20], L2: [50, 20] };

const POSITIONS = {
  0: [
    DEFAULT_POS,
    { L1: [1280, 950], L2: [170, 1000] },
    DEFAULT_POS,
    DEFAULT_POS,
    DEFAULT_POS,
  ],
  1: [
    DEFAULT_POS,
    { L1: [1280, 950], L2: [170, 1000] },
    DEFAULT_POS,
    DEFAULT_POS,
    DEFAULT_POS,
  ],
  2: [
    { L1: [1650, 800], L2: [2650, 1050] },
    { L1: [1300, 600], L2: [200, 950] },
    { L1: [1650, 800], L2: [2650, 1050] },
    { L1: [1650, 800], L2: [2650, 1050] },
    DEFAULT_POS,
  ],
  3: [
    { L1: [2280, 800], L2: [2700, 1000] },
    { L1: [1280, 950], L2: [170, 1000] },
    DEFAULT_POS,
    DEFAULT_POS,
    DEFAULT_POS,
  ],
  4: [
    { L1: [2280, 800], L2: [2700, 1000] },
    { L1: [1280, 950], L2: [170, 1000] },
    DEFAULT_POS,
    DEFAULT_POS,
    DEFAULT_POS,
  ],
};

const RADIUS = {
  1: [DEFAULT_RADIUS, DEFAULT_RADIUS, DEFAULT_RADIUS],
};

const animation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.1 },
};

/** ================= COMPONENT ================= */

export const InnerIsometryLabels = ({
  status,
  rmode,
  showLabel,
  setShowLabel,
  hoveredId,
  hoveredPos,
  index,
  clr,
}) => {
  const labelOptions = getFocus(_bootstrap, "projectnames");

  const [currentLanguage] = useAtom(current_language);
  const isRotateDone = useGet(rotate_by_slider);
  const isDesktop = useBreak("md_up");
const FALLBACK_LABELS = {
  da: [
    { Presentation: "sort 1" },
   
  ],
};
  const { pin } = useGet(active_project);

  /** early exit (cleaner) */
  if (status !== "DONE" || !isRotateDone || !isDesktop) return null;

  // const labels = labelOptions?.[currentLanguage] || [];
  const labels =
  labelOptions?.[currentLanguage] ||
  FALLBACK_LABELS?.[currentLanguage] ||
  [];
  const pinPositions = POSITIONS?.[0]?.[index] || {};
  const pinRadius = RADIUS?.[pin]?.[index] || {};

  return (
    <AnimatePresence>
      {labels.map((label, i) => {
        const key = `L${i + 1}`;
        const pos = pinPositions?.[key];
        const rad = pinRadius?.[key];
        if (!pos) return null;

        return (
          <motion.div key={key} {...animation}>
            <InnerDesktopLabel
              heading={label?.Presentation}
              setShowLabel={setShowLabel}
              c={pos}
              sc={1}
              d={40}
              l={0}
              r={rad}
              rmode={rmode}
              labelsInfo={label}
              showLabel={showLabel}
              hoveredId={hoveredId}
              hoveredPos={hoveredPos}
              clr={clr}
            />
          </motion.div>
        );
      })}
    </AnimatePresence>
  );
};